import { render, staticRenderFns } from "./TravelPlanAddButton.vue?vue&type=template&id=17c87659"
import script from "./TravelPlanAddButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./TravelPlanAddButton.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports